module.exports = __webpack_public_path__ + "static/media/super_pack_fr_printemps_chien.df54ed91.png";